module.exports = __webpack_public_path__ + "static/img/emptyImg.bf8bb865.png";